export const environment = {
   production: 'false',
   influxDbHost: '/tsdata/',
   influxDb: 'lynx',
   influxUser: 'lynx',
   influxPassword: 'lynx',
   graphQlHost: '/back/',
   auth: '/auth/',
   iridium: 'false',
   features: ['tables', 'cranes'],
   graphql: '/graphql',
   hideCodes: 'true',
   tables: 'true',
   gunitadora: 'false',
   incidents: 'false',
   tundish: 'false',
   ordenes: 'false',
   roles: 'devices,alarms,map,last_measures,user_manager, informs,monitor-delayed',
   i18nPath: '/lynx/assets/i18n/',
   assetsDataPath: '/lynx/assets/data/',
   assets3dPath: '/lynx/assets/3d/'
};